import { memo } from 'react';
import styles from '../../publicationDetail.module.scss';
import PublicationDetailMobile from '../../../PublicationDetailMobile/PublicationDetailMobile';
import { PublicationHeaderProps } from '../../interfaces';

const PublicationHeader = ({
  vehicleTypeSelected,
  publication,
  brand,
  type,
  selectedVersion,
  setSelectedVersion,
  loading,
  children,
  logoDealerships,
  handleDealerLogoClick,
  onLinzeCheckClick,
  onAutoFinClick,
  brandsDealerships,
  selectedDealership,
  setSelectedDealership,
  setOpenAdditionalModal
}: PublicationHeaderProps) => {
  return (
    <>
      <h1 className={styles.titleSEO}>
        Auto {vehicleTypeSelected === 'new' ? 'nuevo' : 'usado'} {publication?.vehicle_data?.brand} - Chile
      </h1>
      <PublicationDetailMobile
        brand={brand}
        type={type}
        publication={publication}
        selectedVersion={selectedVersion}
        setSelectedVersion={setSelectedVersion}
        loading={loading}
        children={children}
        logoDealerships={logoDealerships}
        handleDealerLogoClick={handleDealerLogoClick}
        onLinzeCheckClick={onLinzeCheckClick}
        onAutoFinClick={onAutoFinClick}
        vehicleTypeSelected={vehicleTypeSelected}
        brandsDealerships={brandsDealerships}
        selectedDealership={selectedDealership}
        setSelectedDealership={setSelectedDealership}
      />
    </>
  );
};

export default memo(PublicationHeader);
